import SplitLayout from "@components/Footer/SplitLayout";
import LanguageSelector from "@components/LanguageSelector";
import Link from "next/link";
import {useTranslation} from "ni18n";
import React from "react";
import useMediaQuery from "src/useMediaQuery";

import {useV5ImgSrc} from "../../../useV5ImgSrc";
import {v5Pages} from "../../_common/_constants";

const MinimalFooter: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();
  const isSm = useMediaQuery("sm");

  return (
    <nav aria-label={i18n.t("Footer Links")} className="bg-gray100 w100p contrast-tbt">
      <SplitLayout className="pv3 pb5-sm  font-ir fs14 aic fdcr-sm aifs-sm ">
        <div className="fx3 mt2-sm">
          <div className="df aic db-sm">
            <div className="df aic mr18">
              <Link href={{pathname: v5Pages.home}} className="focus-bsDarkBlue3 mr2">
                <img
                  height={25}
                  width={120}
                  src={useV5ImgSrc("/logo", true)}
                  alt="Carbon Health"
                  className="db"
                />
              </Link>
              <span className="gray800 hover-gray800 ">{`© ${new Date().getFullYear()}`}</span>
            </div>
            <div className="df aic mt1-sm">
              <Link
                href={{pathname: v5Pages.privacy}}
                className="gray600 hover-gray800 focus-bsDarkBlue3 mr18 mr0-sm"
                style={{"--br": 0.2}}
              >
                {i18n.t("Privacy Policy")}
              </Link>
              <span className="dn dib-sm fs10 mh2">•</span>
              <Link
                href={{pathname: v5Pages.terms}}
                className="gray600 hover-gray800 focus-bsDarkBlue3"
                style={{"--br": 0.2}}
              >
                {i18n.t("Terms of Service")}
              </Link>
            </div>
          </div>
        </div>
        <div className="fx2">
          <div className="dg gafc gg4 aic maxw20 df-sm fdcr-sm aifs-sm gg2-sm jcfe">
            <span style={{marginLeft: isSm ? -10 : 0}}>
              <LanguageSelector
                className="mr0-f"
                anchorDirection={isSm ? "top left" : "top right"}
              />
            </span>
          </div>
        </div>
      </SplitLayout>
    </nav>
  );
};

export default MinimalFooter;
